var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.717 7.5l.783.783-7.567 7.55h-.766v-.766l7.55-7.567zm3-5a.834.834 0 00-.584.242l-1.525 1.525 3.125 3.125 1.525-1.525c.325-.325.325-.867 0-1.175l-1.95-1.95a.818.818 0 00-.591-.242zm-3 2.658L2.5 14.375V17.5h3.125l9.217-9.217-3.125-3.125z"
  })));
};
export default SvgPencil;